import React, { Component } from "react";

class NoInterviewData extends Component {
  render() {
    return (
      <p>
        No Interview Data Available
      </p>
    );
  }
}

export default NoInterviewData;
